export const heroImage =
  'https://cdn.magicpatterns.com/uploads/kLzLBC53Jmh77N8QatALiQ/ChatGPT_Image_7_sept_2026,_19_53_19.png'

export const worksheetImage =
  'https://cdn.magicpatterns.com/patterns/generated-images/be62454f-340f-4410-967b-88910c447986.jpg'

export const heroTrust = [
  'Download immediato',
  'Accesso a vita incluso',
  'Aggiornamenti gratuiti',
  'Garanzia 30 giorni',
]

export const stats = [
  { value: '+540', label: 'Schede pronte da stampare' },
  { value: '+1.500', label: 'Insegnanti che lo usano' },
  { value: '3.800+', label: 'Ore risparmiate' },
  { value: '98%', label: 'Docenti soddisfatti' },
]

export const microStats = [
  { value: '+540', label: 'Schede pronte da stampare in un clic' },
  { value: '8', label: 'Nuclei tematici completi' },
  { value: '100%', label: 'Allineate ai traguardi ministeriali' },
]

export const problems = [
  'Le domeniche passate a cercare attività su Pinterest che poi non funzionano in classe',
  'Programmazioni riscritte ogni anno da zero perché non trovi mai il file giusto',
  'Bambini che si annoiano davanti alla lezione frontale di scienze',
  'La fotocopiatrice inceppata mentre la classe ti aspetta già seduta',
  'Materiale bello ma senza obiettivi chiari: non sai cosa stai valutando',
]

export const solutions = [
  'Un anno di lezioni di scienze già progettate settimana per settimana',
  'Schede stampabili in bianco e nero, pronte in meno di 5 minuti',
  'Obiettivi di apprendimento e rubriche di valutazione già scritti',
  'Esperimenti facili da fare in classe con materiali di uso quotidiano',
  'Attività differenziate per BES, DSA e per chi finisce prima degli altri',
]

export const situations = [
  {
    icon: '😮\u200d💨',
    text: 'Arrivi a scuola alle 7:40 e stai ancora decidendo cosa fare nell\u2019ora di scienze.',
  },
  {
    icon: '🌀',
    text: 'Hai cartelle piene di file scaricati che non riesci mai a ritrovare al momento giusto.',
  },
  {
    icon: '🕗',
    text: 'Passi le serate a preparare materiali invece di staccare dopo otto ore di classe.',
  },
  {
    icon: '📚',
    text: 'Il libro di testo è troppo teorico e i bambini perdono il filo dopo due pagine.',
  },
  {
    icon: '🤔',
    text: 'Ti senti in colpa perché sai che potresti rendere le scienze molto più belle.',
  },
]

export const packageItems = [
  {
    icon: '📘',
    title: '8 Nuclei Tematici di Scienze',
    subtitle: 'Dal Vivente al Sistema Solare',
    text: 'Ogni nucleo è un percorso completo con introduzione, attività e verifica finale.',
  },
  {
    icon: '🧪',
    title: '32 Esperimenti Facili',
    subtitle: 'Con materiali di casa',
    text: 'Istruzioni passo passo, tempi reali e domande guida per la discussione.',
  },
  {
    icon: '🎯',
    title: 'Griglie di Valutazione',
    subtitle: 'Pronte da compilare',
    text: 'Rubriche allineate ai traguardi di competenza, in formato modificabile.',
  },
  {
    icon: '🗺️',
    title: 'Programmazione Annuale',
    subtitle: 'Settimana per settimana',
    text: 'Un calendario chiaro che ti dice esattamente cosa fare e quando farlo.',
  },
  {
    icon: '📊',
    title: 'Versione BES e DSA',
    subtitle: 'Inclusa senza costi extra',
    text: 'Ogni scheda ha la sua versione semplificata ad alta leggibilità.',
  },
  {
    icon: '🖨️',
    title: 'Formato Stampa Facile',
    subtitle: 'PDF ottimizzato',
    text: 'Bianco e nero, pochi consumi, nessun problema con la fotocopiatrice.',
  },
]

export const previewSlides = [
  {
    image:
      'https://cdn.magicpatterns.com/uploads/7ARaPjj6jk2MRX3gAzwFpu/Captura_de_pantalla_2026-09-08_a_la(s)_12.34.09_a._m..png',
    tag: 'Attività · Esseri viventi',
    title: 'Attività 1 — Colora!',
    text: 'Dodici immagini da colorare di verde o di grigio per distinguere esseri viventi e oggetti non viventi. Consegna breve e autonoma.',
  },
  {
    image:
      'https://cdn.magicpatterns.com/uploads/aiXn6W6CvwGnXW1XZrPfig/Captura_de_pantalla_2026-09-08_a_la(s)_12.34.27_a._m..png',
    tag: 'Attività · I materiali',
    title: 'Classifica per Materiale!',
    text: 'Tabella a doppia entrata con dieci oggetti da collocare tra legno, plastica, metallo, vetro e stoffa.',
  },
  {
    image:
      'https://cdn.magicpatterns.com/uploads/nPaLu85L3S4HEohxTnWck6/Captura_de_pantalla_2026-09-08_a_la(s)_12.34.59_a._m..png',
    tag: 'Attività · Animali e ambienti',
    title: 'Classifica 10 animali nel loro ambiente',
    text: 'Dieci animali illustrati da smistare fra polare, deserto, oceano e foresta, con caselle già pronte per la scrittura.',
  },
  {
    image:
      'https://cdn.magicpatterns.com/uploads/fJoiJM2RXX3g6LACRfHvN4/Captura_de_pantalla_2026-09-08_a_la(s)_12.35.11_a._m..png',
    tag: 'Attività · Stati della materia',
    title: 'Classifica i 9 elementi nei tre stati',
    text: 'Solido, liquido, gassoso: nove immagini da riconoscere più un esempio libero da aggiungere.',
  },
  {
    image:
      'https://cdn.magicpatterns.com/uploads/qhPgNthoPTnVG1cYFJJ2YB/Captura_de_pantalla_2026-09-08_a_la(s)_12.35.31_a._m..png',
    tag: 'Unità 1 · Teoria',
    title: 'Gli Stati della Materia e i Passaggi di Stato',
    text: 'Diagramma dei sei passaggi di stato e curva di riscaldamento dell\u2019acqua: la spiegazione è già impaginata per te.',
  },
  {
    image:
      'https://cdn.magicpatterns.com/uploads/9ZvkXqr1mfHSvjJbqqgyXC/Captura_de_pantalla_2026-09-08_a_la(s)_12.35.53_a._m..png',
    tag: 'Unità 4 · Teoria',
    title: 'La Cellula: l\u2019Unità della Vita',
    text: 'Diagramma comparativo cellula animale e vegetale, con tutte le strutture etichettate e il testo di supporto.',
  },
]

export const bonusTotal = '€116'

export const bonuses = [
  {
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/5b6fcbbe-863d-462a-97ed-f24f696f0354.jpg',
    title: 'Planner Pronto «Settimana di Scienze Senza Stress»',
    text: 'Addio disorganizzazione cronica e alla sensazione che il programma non finisca mai',
    value: 'valore €19',
  },
  {
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/5ff901c3-8171-4364-893e-f6c73dbcd98c.jpg',
    title: 'Kit Aula «Angolo dello Scienziato»',
    text: 'Guida al design educativo e materiali di allestimento per aule vive e motivanti',
    value: 'valore €27',
  },
  {
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/bca26d86-f8b6-4ddf-b9cc-1d39cfd1d736.jpg',
    title: 'Script Pronti «Lezioni di Scienze Senza Improvvisare»',
    text: 'Mai più la paura di restare senza parole davanti a un concetto difficile',
    value: 'valore €36',
  },
  {
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/89c6687e-6761-4343-8ea4-bd0c0f80b857.jpg',
    title: 'Quick Check «Capito Davvero?»',
    text: 'Verifiche brevi che ti dicono subito se stanno imparando, senza correzioni infinite',
    value: 'valore €17',
  },
  {
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/ba20709a-f470-4ccf-97bc-11295ebee125.jpg',
    title: 'Guida Sprint «5 Minuti e Sei Pronta»',
    text: 'Onboarding strategico: non ti senti più sommersa da 600+ pagine di contenuti',
    value: 'valore €17',
  },
]

export const priceRows = [
  { label: 'Pacchetto SCIENZE PRONTA™ (540 schede)', value: '€97' },
  { label: '5 Bonus esclusivi inclusi', value: '€111' },
  { label: 'Aggiornamenti a vita', value: '€49' },
]

export const testimonials = [
  {
    quote:
      'Ho ritrovato le mie domeniche. Preparo la settimana di scienze in venti minuti e i bambini chiedono quando si torna in laboratorio.',
    name: 'Giulia M.',
    role: 'Scuola primaria, Bologna',
  },
  {
    quote:
      'La cosa che mi ha convinta sono le versioni semplificate: finalmente tutta la classe lavora sulla stessa attività, ognuno al suo livello.',
    name: 'Laura P.',
    role: 'Insegnante di sostegno, Torino',
  },
  {
    quote:
      'Materiale serio, allineato alle indicazioni nazionali. L\u2019ho consigliato a tutto il team di plesso dopo due settimane.',
    name: 'Chiara R.',
    role: 'Referente scienze, Bari',
  },
]

export const faqs = [
  {
    q: 'Come ricevo il materiale?',
    a: 'Subito dopo il pagamento ricevi una mail con il link di download. L\u2019accesso è immediato e resta disponibile a vita, anche se cambi computer.',
  },
  {
    q: 'Per quali classi è pensato?',
    a: 'Il pacchetto copre la scuola primaria dalla prima alla quinta: ogni nucleo tematico ha tre livelli di difficoltà, così puoi adattarlo alla tua classe.',
  },
  {
    q: 'Le schede sono adatte a BES e DSA?',
    a: 'Sì. Ogni scheda ha una versione ad alta leggibilità con font dedicato, meno testo e consegne semplificate, inclusa senza costi aggiuntivi.',
  },
  {
    q: 'Cosa succede se non mi trovo bene?',
    a: 'Hai 30 giorni per provare tutto. Se non fa per te scrivi una mail e ti rimborsiamo l\u2019intero importo, senza domande.',
  },
]
